import React, { useContext } from 'react';
import { Box, Flex, Text, Button, VStack, Heading, Icon, Image, Container, HStack } from '@chakra-ui/react';
import { FaWindows, FaAndroid, FaQrcode } from 'react-icons/fa';
import { motion } from 'framer-motion';
import AuthContext from '../services/AuthContext';
import Header from '../layout/Header';
import Footer from '../layout/Footer';

const MotionBox = motion(Box);

const PlatformGate = () => {
  const { logout } = useContext(AuthContext);

  const brandYellow = '#F2C919';
  const lightBg = 'white';
  const primaryText = 'black';

  return (
    <Box dir="rtl" bg={lightBg} minH="100vh" color={primaryText} overflowX="hidden">
      <Header />

      <Container maxW="1200px" py={{ base: 12, md: 24 }}>
        
        {/* Phone Section */}
        <Flex 
          direction={{ base: "column", lg: "row" }} 
          align="center" 
          justify="space-between" 
          mb={{ base: 24, lg: 40 }}
          gap={12}
        >
          {/* Text Content */}
          <VStack align="flex-start" spacing={6} flex={1} textAlign={{ base: "center", lg: "right" }} w="100%">
            <Box>
              <Heading as="h2" fontSize={{ base: "4xl", md: "6xl", lg: "7xl" }} mb={2} color={primaryText} fontFamily="Tajawal, sans-serif" fontWeight="black" lineHeight="1.1">
                تنزيل
              </Heading>
              <Heading as="h3" fontSize={{ base: "3xl", md: "4xl", lg: "5xl" }} mb={4} color="gray.800" fontFamily="Tajawal, sans-serif" fontWeight="bold">
                تطبيق الهاتف
              </Heading>
              <Text fontSize={{ base: "lg", md: "xl" }} color="gray.500" lineHeight="1.8" fontFamily="Tajawal, sans-serif" maxW="500px" mx={{ base: "auto", lg: "0" }}>
                للحصول على أفضل تجربة تعليمية وأمان تام، يرجى استخدام تطبيق الهاتف المخصص للدخول إلى حسابك ومتابعة دروسك في أي وقت ومن أي مكان.
              </Text>
            </Box>

            <HStack spacing={6} justify={{ base: "center", lg: "flex-start" }} w="100%" mt={4}>
              <Box p={3} bg="white" borderRadius="xl" border="2px solid" borderColor="gray.200">
                 <Icon as={FaQrcode} boxSize="60px" color="black" />
              </Box>
              <VStack spacing={3}>
                <Button
                  as="a"
                  href="https://play.google.com/store/apps/details?id=com.geox.cobra&pcampaignid=web_share"
                  size="lg"
                  h="65px"
                  w="200px"
                  bg="black"
                  color="white"
                  rightIcon={<Icon as={FaAndroid} boxSize={8} ml={4} />}
                  _hover={{ transform: 'translateY(-4px)', boxShadow: 'xl', bg: 'gray.800' }}
                  _active={{ transform: 'translateY(0)' }}
                  transition="all 0.3s"
                  borderRadius="md"
                >
                  <VStack spacing={0} align="flex-start">
                    <Text fontSize="xs" color="gray.300" fontWeight="normal" fontFamily="Tajawal, sans-serif">تنزيل نسخة</Text>
                    <Text fontSize="lg" fontWeight="bold" fontFamily="Tajawal, sans-serif">Android</Text>
                  </VStack>
                </Button>
              </VStack>
            </HStack>
          </VStack>

          {/* Phone Mockup */}
          <Flex flex={1} justify="center" align="center" position="relative" w="100%" h="500px">
            {/* Big Yellow Circle */}
            <Box position="absolute" w={{ base: "300px", md: "420px" }} h={{ base: "300px", md: "420px" }} bg={brandYellow} borderRadius="full" zIndex={0} top="50%" left="50%" transform="translate(-50%, -50%)" />
            
            <MotionBox
              initial={{ opacity: 0, y: 50, rotate: 0 }}
              animate={{ opacity: 1, y: 0, rotate: -15 }}
              transition={{ duration: 0.8, type: "spring", bounce: 0.4 }}
              zIndex={1}
            >
              <Box w="240px" h="480px" bg="white" borderRadius="3rem" p={2} boxShadow="2xl" position="relative" border="4px solid" borderColor="gray.300" outline="2px solid white">
                <Box position="absolute" top="12px" left="50%" transform="translateX(-50%)" w="60px" h="15px" bg="gray.200" borderBottomRadius="xl" zIndex={2} />
                <Box w="100%" h="100%" bg="white" borderRadius="2.5rem" overflow="hidden" position="relative" display="flex" flexDirection="column" alignItems="center" justifyContent="center" p={6} border="1px solid" borderColor="gray.100">
                  <Box w="100px" h="100px" bg={brandYellow} borderRadius="2xl" mb={8} display="flex" alignItems="center" justifyContent="center" boxShadow="md">
                    <Image src="/logo512.png" w="60px" />
                  </Box>
                  <Text color="black" fontWeight="black" fontSize="2xl" fontFamily="Tajawal, sans-serif" textAlign="center" lineHeight="1.2">
                    تنزيل<br/>التطبيق
                  </Text>
                  <Text color="gray.500" fontSize="sm" fontFamily="Tajawal, sans-serif" mt={2}>منصة كوبرا</Text>
                </Box>
              </Box>
            </MotionBox>
          </Flex>
        </Flex>

        {/* PC Section */}
        <Flex 
          direction={{ base: "column", lg: "row-reverse" }} 
          align="center" 
          justify="space-between" 
          gap={12}
        >
          {/* Text Content */}
          <VStack align="flex-start" spacing={6} flex={1} textAlign={{ base: "center", lg: "left" }} w="100%" dir="ltr">
            <Box w="100%" textAlign={{ base: "center", lg: "right" }} dir="rtl">
              <Heading as="h2" fontSize={{ base: "4xl", md: "6xl", lg: "7xl" }} mb={2} color={primaryText} fontFamily="Tajawal, sans-serif" fontWeight="black" lineHeight="1.1">
                تنزيل
              </Heading>
              <Heading as="h3" fontSize={{ base: "3xl", md: "4xl", lg: "5xl" }} mb={4} color="gray.800" fontFamily="Tajawal, sans-serif" fontWeight="bold">
                نسخة الحاسوب
              </Heading>
              <Text fontSize={{ base: "lg", md: "xl" }} color="gray.500" lineHeight="1.8" fontFamily="Tajawal, sans-serif" maxW="500px" mx={{ base: "auto", lg: "0" }}>
                استمتع بتجربة دراسية متكاملة ومريحة على شاشة حاسوبك الشخصي. حمل البرنامج الآن وابدأ رحلة التفوق والنجاح.
              </Text>
            </Box>

            <HStack spacing={6} justify={{ base: "center", lg: "flex-start" }} w="100%" mt={4} dir="rtl">
              <Button
                as="a"
                href="https://api.cobra-education.com/uploads/apps/Cobra-Education-Setup.exe"
                size="lg"
                h="65px"
                w="200px"
                bg="black"
                color="white"
                rightIcon={<Icon as={FaWindows} boxSize={8} ml={4} />}
                _hover={{ transform: 'translateY(-4px)', boxShadow: 'xl', bg: 'gray.800' }}
                _active={{ transform: 'translateY(0)' }}
                transition="all 0.3s"
                borderRadius="md"
              >
                <VStack spacing={0} align="flex-start">
                  <Text fontSize="xs" color="gray.300" fontWeight="normal" fontFamily="Tajawal, sans-serif">تنزيل نسخة</Text>
                  <Text fontSize="lg" fontWeight="bold" fontFamily="Tajawal, sans-serif">Windows</Text>
                </VStack>
              </Button>
            </HStack>

            <Button 
              variant="outline" 
              borderColor="red.500"
              color="red.500" 
              _hover={{ bg: "red.50" }}
              onClick={logout}
              size="md"
              fontFamily="Tajawal, sans-serif"
              fontWeight="bold"
              mt={8}
              mx={{ base: "auto", lg: "0" }}
              w={{ base: "100%", md: "200px" }}
              alignSelf={{ base: "center", lg: "flex-end" }}
            >
              تسجيل الخروج
            </Button>
          </VStack>

          {/* PC Mockup */}
          <Flex flex={1} justify="center" align="center" position="relative" w="100%" h="500px">
            {/* Big Blue Circle */}
            <Box position="absolute" w={{ base: "300px", md: "420px" }} h={{ base: "300px", md: "420px" }} bg="blue.400" borderRadius="full" zIndex={0} top="50%" left="50%" transform="translate(-50%, -50%)" />
            
            <MotionBox
              initial={{ opacity: 0, x: -50, rotate: 0 }}
              animate={{ opacity: 1, x: 0, rotate: 10 }}
              transition={{ duration: 0.8, type: "spring", bounce: 0.4, delay: 0.2 }}
              zIndex={1}
            >
              <Box w={{ base: "300px", md: "420px" }} h={{ base: "190px", md: "260px" }} bg="white" borderRadius="xl" p={2} borderBottomRadius="none" position="relative" boxShadow="2xl" border="4px solid" borderColor="gray.300" outline="2px solid white">
                <Box position="absolute" top="4px" left="50%" transform="translateX(-50%)" w="4px" h="4px" bg="gray.300" borderRadius="full" />
                <Box w="100%" h="100%" bg="white" borderRadius="md" overflow="hidden" position="relative" display="flex" flexDirection="column" alignItems="center" justifyContent="center" border="1px solid" borderColor="gray.100">
                  <Box w="80px" h="80px" bg="blue.400" borderRadius="2xl" mb={4} display="flex" alignItems="center" justifyContent="center" boxShadow="md">
                     <Image src="/logo512.png" w="50px" />
                  </Box>
                  <Text color="black" fontWeight="black" fontSize="2xl" fontFamily="Tajawal, sans-serif" textAlign="center" lineHeight="1.2">
                    نسخة<br/>الحاسوب
                  </Text>
                </Box>
              </Box>
              {/* Base */}
              <Box w={{ base: "350px", md: "480px" }} h="14px" bg="gray.100" borderBottomRadius="xl" position="relative" left="50%" transform="translateX(-50%)" boxShadow="xl" border="1px solid" borderColor="gray.300">
                <Box position="absolute" top="0" left="50%" transform="translateX(-50%)" w="60px" h="4px" bg="gray.400" borderBottomRadius="sm" />
              </Box>
            </MotionBox>
          </Flex>
        </Flex>

      </Container>
      
      <Footer />
    </Box>
  );
};

export default PlatformGate;
